import { when } from 'mobx';
import { inject, observer } from 'mobx-react';
import { parse } from 'query-string';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { LoginWithFacebook } from '../../_components/LoginWithFacebook/LoginWithFacebook';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { isSuccessfulFacebookAuthResponse } from '../../_stores/AuthorizationStore';
import { TightKnitLogoWhite } from '../../images/images';
import { assertIsString } from '../../util/string.utils';
import './AuthPages.css';

import InfoCard from './InfoCard';
import LoginForm from './LoginForm';

export enum ActionState {
    LOGIN,
    SIGNUP,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
}

interface ICredentials {
    email: string,
    password: string
}

interface IServerErrorWarning {
    friendlyMessage: string,
    message: string
}

interface IState {
    credentials: ICredentials;
    isLoggingIn: boolean;
    serverErrorWarning?: IServerErrorWarning;
    wasInvited: boolean;
}

interface IProps {
    store: ApplicationStore;
}

@inject('store')
@observer
export class LoginPage extends React.Component<IProps & RouteComponentProps<any>, IState> {
    private _loginListenerDisposer = () => { return; };

    public state: IState = {
        credentials: {
            email: '',
            password: ''
        },
        isLoggingIn: false,
        wasInvited: false
    };

    public componentDidMount(): void {

        this._loginListenerDisposer = when(
            () =>
                this.props.store &&
                this.props.store.authorizationStore.isAuthenticated &&
                this.props.store.authorizationStore.authIsResolved &&
                this.props.store.storeIsReady,
            () => {
                console.log('isNewUser', this.props.store.authorizationStore.isNewUser);
                if (this.props.store.authorizationStore.isNewUser) {
                    this.props.history.push(Routes.ONBOARDING_WELCOME, { wasInvited: this.state.wasInvited });
                } else {
                    this.props.history.push(Routes.ALBUMS);
                }
            },
        );

        // TODO: make sure this works
        if (this.props.location && this.props.location.search) {
            const query = this.props.location.search;
            const parsedQuery = parse(query);
            if (parsedQuery.invite_key && assertIsString(parsedQuery.invite_key) && assertIsString(parsedQuery.email)) {
                    const inviteKey = decodeURIComponent(parsedQuery.invite_key);
                    const email = decodeURIComponent(parsedQuery.email);
                    this.setState({ credentials: {email, password: ''} });
                    this.setState({ wasInvited: true });
                    this.props.store.onboardingStore.setInvitedUserInformation(inviteKey, email);
            }
        }
    }

    public componentWillUnmount(): void {
        this._loginListenerDisposer();
    }

    private onClickFacebookLogin() {
        // console.log('onClickFacebookLogin');
    }

    private async responseFacebook(response: any) {
        console.log('responseFacebook: ', response);

        if (isSuccessfulFacebookAuthResponse(response)) {
            await this.props.store.authorizationStore.loginWithFacebook(response)
            .catch(err => this.handleAuthFailure(err));
        } else {
            this.handleAuthFailure(new Error('Invalid facebook api response'));
        }

    }

    private handleAuthFailure(error: any) {
        switch (error) {
            case 'Missing credentials':
                this.setState({
                    serverErrorWarning: {
                        message: error,
                        friendlyMessage: 'Email and password are required'
                    }
                });
                break;
            case 'invalid email in log in request':
                this.setState({
                    serverErrorWarning: {
                        message: error,
                        friendlyMessage: 'Email is poorly formatted'
                    }
                });
                break;
            case 'no user found.':
            case 'login.password.fail':
                this.setState({
                    serverErrorWarning: {
                        message: error,
                        friendlyMessage: 'Email or password is incorrect'
                    }
                });
                break;
            default:
                console.log('No error match for', error);
                this.setState({
                    serverErrorWarning: {
                        message: error,
                        friendlyMessage: 'An unrecognized error occurred. Please try again later'
                    }
                });
        }
    }


    public handleSubmit = (isValid: boolean) => {
        if (isValid) {
            this.setState({ isLoggingIn: true }, async () => {
                try {
                    await this.props.store.authorizationStore.login(this.state.credentials.email, this.state.credentials.password);
                    this.setState({ serverErrorWarning: undefined });
                    this.setState({isLoggingIn: false});
                } catch (error) {
                    this.handleAuthFailure(error);
                    this.setState({isLoggingIn: false});
                }
            });
        }
    }

    private setCredentials = (credentials: ICredentials) => {
        this.setState({credentials});
    }

    public render() {
        return (
            <div className="auth-page">
                <div className="auth-page__logo">
                    <img src={TightKnitLogoWhite} className="logoImage "/>
                </div>

                <div className="auth-page__cards">
                    <InfoCard></InfoCard>
                    <div className="auth-page__card">

                        <h1 className="auth-page__card__header">Member Login</h1>

                        <LoginForm
                            credentials={this.state.credentials}
                            error={this.state.serverErrorWarning}
                            handleSubmit={this.handleSubmit}
                            isLoggingIn={this.state.isLoggingIn}
                            setCredentials={this.setCredentials}
                        />

                        <Link className="auth-page__help-text" to="/facebook-reset" style={{marginTop: 20}}>
                            Previously signed up using Facebook?
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/LoginPage.tsx